import getSingleItemProductString from "../getSingleItemProductString";

const getProductsString = items =>
  items
    .map(
      ({
        productId,
        variantId,
        source,
        seller,
        isProductInStock,
        isRestockingSoon,
        earlyAccess
      }) =>
        getSingleItemProductString({
          productId,
          variantId,
          source,
          seller,
          isRestockingSoon,
          isProductInStock,
          earlyAccess
        })
    )
    .join(",");

export default getProductsString;
